export default {
  // Page metadata
  'meta.title': 'Nutzungsbedingungen - timer.today',
  'meta.description': 'Nutzungsbedingungen und Nutzungsvereinbarung für die Online-Zeitmessungstools-Plattform timer.today. Erfahren Sie mehr über unsere Serviceregeln, Benutzerrechte und -pflichten.',

  // Page header
  'page.title': 'Nutzungsbedingungen',
  'page.lastUpdated': 'Zuletzt aktualisiert: {{date}}',
  'page.intro': 'Willkommen bei timer.today. Diese Allgemeinen Geschäftsbedingungen beschreiben die Regeln und Vorschriften für die Nutzung der Website von timer.today unter timer.today.',

  // Section 1
  'section1.title': '1. Annahme der Bedingungen',
  'section1.content': 'Durch den Zugriff auf und die Nutzung dieser Website akzeptieren und stimmen Sie zu, an die Bedingungen und Bestimmungen dieser Vereinbarung gebunden zu sein. Wenn Sie mit dem oben Genannten nicht einverstanden sind, nutzen Sie bitte diesen Dienst nicht.',

  // Section 2
  'section2.title': '2. Dienstbeschreibung',
  'section2.intro': 'timer.today bietet kostenlose Online-Zeitmessungstools, darunter:',
  'section2.timer': 'Countdown-Timer - Anpassbarer Timer für Produktivität, Kochen und Zeitmanagement',
  'section2.stopwatch': 'Stoppuhr - Hochpräzises Timing-Tool für Sport, Training und präzise Zeitmessung',
  'section2.worldclock': 'Weltuhr - Echtzeit-Anzeige globaler Zeitzonen',

  // Section 3
  'section3.title': '3. Nutzungslizenz',
  'section3.intro': 'Die Erlaubnis wird erteilt, timer.today vorübergehend nur zur persönlichen, nicht-kommerziellen vorübergehenden Ansicht zu nutzen. Dies ist die Gewährung einer Lizenz, keine Eigentumsübertragung, und unter dieser Lizenz dürfen Sie nicht:',
  'section3.item1': 'die Materialien ändern oder kopieren',
  'section3.item2': 'die Materialien für kommerzielle Zwecke oder zur öffentlichen Anzeige verwenden',
  'section3.item3': 'versuchen, Software auf der Website zurückzuentwickeln',
  'section3.item4': 'Urheber- oder andere Eigentumshinweise von den Materialien entfernen',

  // Section 4
  'section4.title': '4. Datenschutz und Daten',
  'section4.intro': 'timer.today verpflichtet sich, Ihre Privatsphäre zu schützen:',
  'section4.item1': 'Wir sammeln oder speichern keine persönlichen Informationen',
  'section4.item2': 'Timer-Einstellungen werden lokal in Ihrem Browser gespeichert',
  'section4.item3': 'Wir verfolgen kein Benutzerverhalten oder Nutzungsmuster',
  'section4.item4': 'Es werden keine Cookies zu Tracking-Zwecken verwendet',

  // Section 5
  'section5.title': '5. Haftungsausschluss',
  'section5.content': 'Die Materialien auf timer.today werden auf einer „Wie besehen"-Basis bereitgestellt. timer.today gibt keine Garantien, weder ausdrücklich noch stillschweigend, ab und lehnt hiermit alle anderen Garantien ab, einschließlich, aber nicht beschränkt auf stillschweigende Garantien oder Bedingungen der Marktgängigkeit, Eignung für einen bestimmten Zweck oder Nichtverletzung geistigen Eigentums oder anderer Rechtsverletzungen.',

  // Section 6
  'section6.title': '6. Einschränkungen',
  'section6.content': 'In keinem Fall haften timer.today oder seine Lieferanten für Schäden (einschließlich, aber nicht beschränkt auf Schäden durch Datenverlust oder entgangenen Gewinn oder aufgrund von Geschäftsunterbrechungen), die sich aus der Nutzung oder der Unfähigkeit zur Nutzung der Materialien auf timer.today ergeben, selbst wenn timer.today oder sein autorisierter Vertreter mündlich oder schriftlich über die Möglichkeit solcher Schäden informiert wurde.',

  // Section 7
  'section7.title': '7. Genauigkeit der Materialien',
  'section7.content': 'Die auf timer.today erscheinenden Materialien können technische, typografische oder fotografische Fehler enthalten. timer.today garantiert nicht, dass die Materialien auf seiner Website korrekt, vollständig oder aktuell sind. timer.today kann jederzeit ohne Vorankündigung Änderungen an den auf seiner Website enthaltenen Materialien vornehmen.',

  // Section 8
  'section8.title': '8. Änderungen',
  'section8.content': 'timer.today kann diese Nutzungsbedingungen für seine Website jederzeit ohne Vorankündigung überarbeiten. Durch die Nutzung dieser Website erklären Sie sich damit einverstanden, an die dann aktuelle Version dieser Nutzungsbedingungen gebunden zu sein.',

  // Section 9
  'section9.title': '9. Kontaktinformationen',
  'section9.intro': 'Wenn Sie Fragen zu diesen Nutzungsbedingungen haben, kontaktieren Sie uns bitte unter:',
  'section9.email': 'E-Mail:',
  'section9.emailSubject': 'Anfrage zu Nutzungsbedingungen - timer.today',

  // Footer
  'footer.copyright': '© timer.today 2024. Alle Rechte vorbehalten.'
};
